// English should be first so it appears as the default selected language
const LANGUAGES = [
    { locale: 'en_US', weglot: 'en', name: 'English (US)' },
    // { locale: 'en_GB', weglot: 'en-gb', name: 'English (UK)' }, // Uncomment when guild updates weglot contract to support more than 10 languages and if its determined that English UK is worthy to support
    { locale: 'fr_CA', weglot: 'fr-ca', name: 'French (Canada)' },
    { locale: 'ja_JP', weglot: 'ja-jp', name: 'Japanese' },
    { locale: 'zh_CN', weglot: 'zh', name: 'Chinese (Simplified)' },
    { locale: 'de_DE', weglot: 'de-de', name: 'German' },
    { locale: 'pl_PL', weglot: 'pl-pl', name: 'Polish' },
    { locale: 'pt_BR', weglot: 'pt-br', name: 'Portuguese' },
    { locale: 'es_MX', weglot: 'es-mx', name: 'Spanish (Mexico)' },
    { locale: 'th_TH', weglot: 'th-th', name: 'Thai' },
    { locale: 'tl_PH', weglot: 'tl', name: 'Tagalog/Filipino' },
    { locale: 'vi_VN', weglot: 'vi', name: 'Vietnamese' },
];
/**
 * Supported locales array derived from LANGUAGES config.
 */
export const SUPPORTED_LOCALES = LANGUAGES.map(lang => ({
    name: lang.name,
    label: lang.locale.split('_')[0].toUpperCase(),
    locale: lang.locale,
    value: lang.weglot,
}));
/**
 * Helper function to find a locale by its code
 */
export const findLocaleByCode = (localeCode) => {
    return SUPPORTED_LOCALES.find(lang => lang.locale === localeCode);
};
/**
 * Get the display name for a language code.
 * Automatically derives short display name by removing country suffix from full name.
 *
 * @param languageCode - ISO 639-1 language code (e.g., 'en', 'es', 'fr')
 * @returns The display name of the language (e.g., 'English', 'Spanish', 'French')
 *          or the language code itself if no mapping is found
 * @example
 * getLanguageDisplayName('en') // returns 'English'
 * getLanguageDisplayName('es') // returns 'Spanish'
 * getLanguageDisplayName('unknown') // returns 'unknown'
 */
export const getLanguageDisplayName = (languageCode) => {
    const lang = LANGUAGES.find(l => l.weglot.startsWith(languageCode));
    if (!lang)
        return languageCode;
    // Remove country suffix: "English (US)" → "English", "German" → "German"
    return lang.name.replace(/\s*\([^)]*\)\s*$/, '');
};
